import { FC, useState } from 'react';

import {
    Alert,
    Box,
    IconButton,
    Icons,
    Typography,
} from '@thirdspacelearning/library';

import { MaintenanceFlag } from '../types';

const sx = {
    root: {
        position: 'fixed',
        zIndex: 9999,
        top: 0.5,
        left: '50%',
        transform: 'translateX(-50%)',
    },
    alert: {
        display: 'inline-flex',
        width: 'max-content',
        maxWidth: '100vw',
        '& .MuiAlert-icon': { py: 0.5 },
        '& .MuiAlert-message': { py: 0.5 },
        '& .MuiAlert-action': { alignItems: 'center', py: 0 },
    },
};

type Props = { flag: MaintenanceFlag };

const MaintenanceBanner: FC<Props> = ({ flag }) => {
    const { title, message } = flag;

    const [show, setShow] = useState(true);

    const onClose = () => {
        setShow(false);
    };

    return (
        show && (
            <Box sx={sx.root}>
                <Alert
                    icon={<Icons.WarningAmberOutlined />}
                    severity="warning"
                    variant="outlined"
                    elevation={0}
                    action={
                        <IconButton onClick={onClose}>
                            <Icons.Close fontSize="small" color="action" />
                        </IconButton>
                    }
                    sx={sx.alert}
                >
                    <Box
                        display="flex"
                        alignItems="flex-end"
                        flexWrap="wrap"
                        columnGap={4}
                    >
                        <Typography
                            variant="body1"
                            fontWeight="bold"
                            color="grey.800"
                        >
                            {title || 'Platform under maintenance'}
                        </Typography>
                        <Typography variant="body2" color="grey.700">
                            {message ||
                                'Some features may be temporarily unavailable.'}
                        </Typography>
                    </Box>
                </Alert>
            </Box>
        )
    );
};

export default MaintenanceBanner;
